/* eslint-disable no-param-reassign */
export function addCountryObject(address: $TSFixMe, countries: $TSFixMe) {
  if (address && address.countryCode) {
    address.country = countries.countries.find(
      (c: $TSFixMe) => c.code === address.countryCode,
    );
  } else if (address != null) {
    address.country = countries.countries.find(
      (c: $TSFixMe) => c.code === countries.userCountryCode,
    );
  }
  return address;
}
